import {Snackbar} from "@mui/material";
import {Alert} from "@mui/lab";
import React from "react";
import useSnackBar from './../hooks/useSnackBar'

const FastSnackBar = () => {

    const {isSnackBar, setSnackBar} = useSnackBar()
    const handleCloseSnackbar = () => {
        setSnackBar({status:'error',title:'error',isActive:false});
    }
    return <Snackbar open={isSnackBar.isActive} autoHideDuration={6000} onClose={handleCloseSnackbar}
                     anchorOrigin={{vertical: 'top', horizontal: 'right'}}>
        <Alert onClose={handleCloseSnackbar} severity={isSnackBar.status} sx={{width: '100%'}}>
            {isSnackBar.title}
        </Alert>
    </Snackbar>

}
export default FastSnackBar